import { UstraPlugin } from '../ustra-plugin'

/**
 * detect static resource error
 */
export const detectError = ($ustra: UstraPlugin) => {
  if ($ustra.context.isStatic) {
    const data = $ustra.utils.nuxt.getStaticServerData()

    if (data?.serverData?.hasError) {
      $ustra.logger().error('server error detected..', data.serverData)
      $ustra.definedStore.core.setServerError({
        status: 500,
        message: data.serverData.resultMessage,
      })
    }
  }
}
